export const getUserInfo = (state) => state.userInfo;
